(function () {
    'use strict';

    angular.module("imApp").factory("stockAllService", ['$ihttp', function ($ihttp) {
        let service = {
            listStockAlls: function (parms) {
                return $ihttp.post({
                    method: 495,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
